'use client';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { copyToClipboard } from '@bridge/utils';
import toast from 'react-hot-toast';

import { faClipboard } from '@icons/classic/regular';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './Tooltip';

export interface CopyButtonProps {
  value: string;
  className?: string;
  tooltip?: string;
}

/**
 * A small copy icon button that copies the given value to clipboard and shows a toast.
 */
export function CopyButton({ value, className, tooltip = 'Copy to clipboard' }: CopyButtonProps) {
  async function handleCopy() {
    const success = await copyToClipboard(value);
    if (success) {
      toast.success('Copied to clipboard');
    } else {
      toast.error('Failed to copy');
    }
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            className={className ?? 'cursor-pointer text-content-secondary hover:text-content-primary transition-colors shrink-0'}
            onClick={handleCopy}
            type="button"
          >
            <FontAwesomeIcon icon={faClipboard} size="sm" />
          </button>
        </TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
